<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="proxySave()"
  >
    <page-template>
      <template #title>
        <div
          class="d-flex align-center justify-start pa-8"
        >
          <page-title
            :title="getPageTitle"
            :back-to="navigateBackRoute"
          />
        </div>
      </template>
      <template #content>
        <v-row>
          <v-col cols="12">
            <v-container
              class="py-0"
              fluid
              grid-list-xl
            >
              <v-row>
                <form-group>
                  <v-stepper
                    v-model="stepper"
                  >
                    <v-stepper-header>
                      <v-stepper-step
                        v-for="(step, idx) in steps"
                        :key="`step_header_${step.value}_${idx}`"
                        :complete="stepper > step.value"
                        :step="step.value"
                        editable
                      >
                        {{ step.text }}
                      </v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(step, idx) in steps"
                        :key="`step_content_${step.value}_${idx}`"
                        :step="step.value"
                      >
                        <v-row>
                          <v-col cols="12">
                            <component
                              :is="step.component"
                              :ref="step.ref"
                              @to-message-tab="handleToMessageTab($event)"
                            >
                              <notification-action-form
                                :back-route="navigateBackRoute"
                                :next="idx < (steps.length - 1)"
                                :edit="isEdit"
                                @nextStep="handleStep(step.value + 1)"
                              />
                            </component>
                          </v-col>
                        </v-row>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </form-group>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import PageTemplate from '@/app/arch/template/PageTemplate.vue';
import PageTitle from '@/app/arch/template/PageTitle.vue';
import NotificationConfigContent from 'Modules/contacard/communication/notifications/components/contents/NotificationConfigContent.vue';
import NotificationActionForm from 'Modules/contacard/communication/notifications/components/buttons/NotificationActionForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import NotificationUsersContent from 'Modules/contacard/communication/notifications/components/contents/NotificationUsersContent.vue';
import NotificationMessageContent from 'Modules/contacard/communication/notifications/components/contents/NotificationMessageContent.vue';
import NotificationReviewContent from 'Modules/contacard/communication/notifications/components/contents/NotificationReviewContent.vue';
import NotificationFormMixin from 'Modules/contacard/communication/notifications/NotificationFormMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';

const faultPayload = {
  push: {
    title: '',
    body: '',
    routeId: '',
    subRoute: '',
    bodyHtml: '',
    communicationId: '',
    isDraft: false,
  },
  email: {
    communicationId: '',
    title: '',
    body: '',
    isDraft: false,
    createdById: '',
    createdByName: '',
    updatedById: '',
    updatedByName: '',
    deletedById: '',
    deletedByName: '',
    id: '',
    createdAt: '',
    updatedAt: '',
    isActive: '',
  },
  sms: {
    body: '',
    communicationId: '',
    isDraft: false,
    id: '',
  },
  title: '',
  description: '',
  status: '',
  scheduledDate: '',
  userFilter: {},
  sendPush: true,
  sendEmail: true,
  sendSms: true,
};

export default {
  name: 'NotificationsForm',
  components: {
    PageTemplate,
    PageTitle,
    NotificationConfigContent,
    NotificationActionForm,
    FormGroup,
    NotificationUsersContent,
    NotificationMessageContent,
    NotificationReviewContent,
  },
  mixins: [NotificationFormMixin, NotificationMixin],
  data: () => ({
    formValid: false,
    loading: false,
    stepper: 1,
    status: '',
    steps: [
      {
        text: 'Configuração',
        component: 'NotificationConfigContent',
        value: 1,
      },
      {
        text: 'Público alvo',
        component: 'NotificationUsersContent',
        value: 2,
      },
      {
        text: 'Notificações',
        component: 'NotificationMessageContent',
        ref: 'messages',
        value: 3,
      },
      {
        text: 'Revisão',
        component: 'NotificationReviewContent',
        value: 4,
      },
    ],
    payload: {
      ...faultPayload,
    },
    notificationFilters: {},
    notificationList: [],
  }),
  computed: {
    getId() {
      return this.$route.params.id;
    },
    isEdit() {
      return Number(this.getId) >= 1;
    },
    getPageTitle() {
      return this.isEdit ? 'Visualizar notificação' : 'Criar notificação';
    },
    navigateBackRoute() {
      const { breadcrumbs } = this.$route.meta;
      return Array.isArray(breadcrumbs)
        ? breadcrumbs[breadcrumbs.length - 2].to : 'contacard.submodules.list';
    },
    refMessage() {
      const { messages } = this.$refs;
      if (!messages) {
        return {
          handleTab: (v) => v,
        };
      }
      if (Array.isArray(messages)) {
        return messages[0];
      }
      return messages;
    },
    refForm() {
      const { form } = this.$refs;
      return form || {
        validate: () => {},
      };
    },
    getPagePath() {
      return this.$route.path;
    },
  },
  watch: {
    getPagePath: {
      immediate: true,
      handler(path) {
        if (path) {
          this.payload = { ...faultPayload };
        }
      },
    },
    'payload.status': {
      immediate: true,
      handler(status) {
        if (status) {
          this.handleStatus(status);
        }
      },
    },
  },
  methods: {
    proxySave() {
      if (this.refForm.validate()) {
        this.save();
        return;
      }
      this.showFormsErrors();
    },
    showFormsErrors() {
      this.showErrorToast({
        title: 'Ocorreu um erro!',
        text: 'Preencha os dados corretamente.',
      });
    },
    handleStep(step) {
      this.stepper = step;
    },
    handleUsersFilter(filters = {}) {
      this.payload.userFilter = filters;
    },
    handleUsersList(userSystemIds = []) {
      const { userFilter } = this.payload;
      this.payload.userFilter = {
        ...(userFilter ?? {}),
        userSystemIds,
      };
    },
    handleClientList(clientIds = []) {
      const { userFilter } = this.payload;
      this.payload.userFilter = {
        ...(userFilter ?? {}),
        clientIds,
      };
    },
    handleNotificationFilters(filters = {}) {
      this.notificationFilters = filters;
    },
    handleNotificationList(userSystemIds = []) {
      const { userFilter } = this.payload;
      this.payload.userFilter = {
        ...(userFilter ?? {}),
        userSystemIds,
      };
    },
    handleSelectedMessage(message, bool) {
      this.payload[message] = bool;
    },
    handleToMessageTab(tab) {
      this.stepper = 3;
      this.$nextTick(
        () => {
          this.refMessage.handleTab(tab);
        },
      );
    },
    handelMessagesDraft(bool) {
      this.payload.sms.isDraft = bool;
      this.payload.push.isDraft = bool;
      this.payload.email.isDraft = bool;
    },
    handleScheduleDate(date) {
      this.payload.scheduledDate = date;
    },
    handleStatus(status) {
      this.status = status;
    },
  },
  provide() {
    return {
      handleUsersFilter: this.handleUsersFilter,
      handleNotificationFilters: this.handleNotificationFilters,
      handleNotificationList: this.handleNotificationList,
      handleUsersList: this.handleUsersList,
      handleSelectedMessage: this.handleSelectedMessage,
      handelMessagesDraft: this.handelMessagesDraft,
      handleScheduleDate: this.handleScheduleDate,
      handleStatus: this.handleStatus,
      submitForm: this.proxySave,
      handleClientList: this.handleClientList,
    };
  },
  reactiveProvide: {
    name: 'notification',
    include: ['payload', 'loading', 'notificationFilters', 'notificationList', 'status'],
  },
};
</script>
